import styled, { keyframes } from "styled-components";

import { DATA_E2E_KEY, IStyledAttributes } from "@ryde/shared";
import { greyMui, MOBILE_BREAKPOINT, rydeColors } from "@ryde/theme";

// `venetianNights` is a 6-digit hex, so an alpha suffix (80 ≈ 0.5, 00 = 0) yields the rgba fade.
const pulse = keyframes`
  0% {
    box-shadow: 0 0 0 0 ${rydeColors.venetianNights}80;
  }
  70% {
    box-shadow: 0 0 0 6px ${rydeColors.venetianNights}00;
  }
  100% {
    box-shadow: 0 0 0 0 ${rydeColors.venetianNights}00;
  }
`;

export const SelectedRowsToggleWrapper = styled.div.attrs<IStyledAttributes>({
  [DATA_E2E_KEY]: "selected-rows-toggle",
})`
  .selected-rows-button {
    padding-inline: 6px;
    min-width: 65px;
    gap: 5px;
    border-color: ${greyMui._300};
    color: ${rydeColors.black};
    text-transform: none;

    &:hover {
      background-color: ${rydeColors.focusedOption};
    }

    &.active {
      border-color: ${rydeColors.venetianNights};
      background-color: ${rydeColors.neonBoneyard};
      animation: ${pulse} 1.8s ease-out infinite;

      @media (prefers-reduced-motion: reduce) {
        animation: none;
      }
    }

    @media (max-width: ${MOBILE_BREAKPOINT}) {
      min-width: 0;
      padding-inline: 2px;
      gap: 2px;
    }

    .selected-rows-icon {
      font-size: 20px;
      color: ${greyMui._600};

      @media (max-width: ${MOBILE_BREAKPOINT}) {
        margin-inline-end: -2px;
      }
    }

    &.active .selected-rows-icon {
      color: ${rydeColors.venetianNights};
    }
  }
`;
